import React from 'react';
import {
  FiAlertTriangle,
  FiArchive,
  FiArrowLeftCircle,
  FiArrowRight,
  FiAward,
  FiBarChart2,
  FiBell,
  FiBookOpen,
  FiBriefcase,
  FiCalendar,
  FiCheck,
  FiChevronDown,
  FiChevronLeft,
  FiChevronRight,
  FiChevronUp,
  FiClipboard,
  FiCopy,
  FiCreditCard,
  FiDatabase,
  FiFile,
  FiDollarSign,
  FiDownload,
  FiEdit2,
  FiEye,
  FiEyeOff,
  FiFileText,
  FiFilter,
  FiFolder,
  FiGift,
  FiGlobe,
  FiGrid,
  FiHeadphones,
  FiLayers,
  FiList,
  FiLock,
  FiMail,
  FiMapPin,
  FiMessageCircle,
  FiMenu,
  FiMoreHorizontal,
  FiMinus,
  FiLogIn,
  FiLogOut,
  FiPackage,
  FiPieChart,
  FiPercent,
  FiPlus,
  FiPhoneCall,
  FiPaperclip,
  FiPrinter,
  FiRepeat,
  FiRotateCw,
  FiRss,
  FiSave,
  FiSearch,
  FiSend,
  FiSettings,
  FiShare2,
  FiShuffle,
  FiShoppingBag,
  FiShoppingCart,
  FiTag,
  FiTool,
  FiTrash2,
  FiTrendingDown,
  FiTrendingUp,
  FiTruck,
  FiUpload,
  FiUser,
  FiUserCheck,
  FiUserPlus,
  FiUsers,
  FiX,
  FiCornerUpLeft,
  FiClock,
} from 'react-icons/fi';
import { FaBarcode } from 'react-icons/fa';
import { LuFileSignature } from 'react-icons/lu';

const DISPLAY_LABEL_MAP = {
  'benh vien': 'Chi nhánh / Cửa hàng',
  'quan he co dong': 'Tin tức nội bộ',
  'xet nghiem tai nha': 'Đang giao hàng',
  'chuyen gia bac si': 'Nhân sự',
  'bang dieu khien': 'Bảng điều khiển',
  'giao viec': 'Giao việc',
  'san pham dich vu': 'Sản phẩm - Dịch vụ',
  'quan ly noi dung': 'Quản lý nội dung',
  'tuyen dung': 'Tuyển dụng',
  'he thong': 'Hệ thống',
  'khach hang': 'Khách hàng',
  'khuyen mai': 'Khuyến mại',
  'tai chinh': 'Tài chính',
  'ke toan': 'Kế toán',
  'mua hang': 'Mua hàng',
  kho: 'Kho',
  'ban hang': 'Bán hàng',
  'bao cao': 'Báo cáo',
  'du an': 'Dự án',
  'gia san pham': 'Giá sản phẩm',
  'bao gia': 'Báo giá',
  'muon tra hang': 'Mượn - Trả hàng',
  'tai lieu': 'Tài liệu',
  'thong bao': 'Thông báo',
  'tin tuc': 'Tin tức',
  'chung tu nghiep vu khac': 'Chứng từ nghiệp vụ khác',
  'chuyen tien noi bo': 'Chuyển tiền nội bộ',
  'cong no phai tra': 'Công nợ phải trả',
  'hoa don': 'Hóa đơn',
  'phieu thu chi tien mat': 'Phiếu thu chi - Tiền mặt',
  'phieu thu chi tien ngan hang': 'Phiếu thu chi - Tiền ngân hàng',
  'cong no': 'Công nợ',
  'khai bao': 'Khai báo',
  'hinh thuc chuyen tien noi bo': 'Hình thức chuyển tiền nội bộ',
  'quan ly doi tac tra gop': 'Quản lý đối tác trả góp',
  'quan ly hinh thuc thanh toan': 'Quản lý hình thức thanh toán',
  'quan ly hinh thuc tra gop': 'Quản lý hình thức trả góp',
  'quan ly loai thu': 'Quản lý loại thu',
  'quan ly loai chi': 'Quản lý loại chi',
  'tai khoan ke toan': 'Tài khoản kế toán',
  'quan ly tai khoan ngam dinh': 'Quản lý tài khoản ngầm định',
  'quan ly ngan hang': 'Quản lý ngân hàng',
  'quan ly tai khoan ngan hang': 'Quản lý tài khoản ngân hàng',
  'ky ke toan': 'Kỳ kế toán',
};

const DISPLAY_LABEL_RULES = [
  { pattern: /\bbenh vien\b/, value: 'Chi nhánh / Cửa hàng' },
  { pattern: /\bco dong\b/, value: 'Tin tức nội bộ' },
  { pattern: /\bxet nghiem tai nha\b/, value: 'Đang giao hàng' },
  { pattern: /\bchuyen gia\b|\bbac si\b/, value: 'Nhân sự' },
];

const MENU_ICON_RULES = [
  { pattern: /(bang dieu khien|trang chu|dashboard)/, key: 'dashboard', icon: 'fi fi-rr-apps' },
  { pattern: /(giao viec|assign|task)/, key: 'task', icon: 'fi fi-rr-list-check' },
  {
    pattern:
      /(lich cong tac|dang ky lich|dat lich|booking|calendar|nghi phep|chuyen ca|ket ca|ca lam|time keeping|cham cong)/,
    key: 'calendar',
    icon: 'fi fi-rr-calendar',
  },
  {
    pattern: /(cham soc 360|cskh|customer care|care service|testimonial|cam nhan khach hang)/,
    key: 'support',
    icon: 'fi fi-rr-headset',
  },
  { pattern: /(tong dai|hotline|voidip|call|phone)/, key: 'phone', icon: 'fi fi-rr-phone-call' },
  {
    pattern: /(facebook|zalo|instagram|website|connect|email marketing|landing page|sale channel|kenh ban|trang web)/,
    key: 'channel',
    icon: 'fi fi-rr-globe',
  },
  {
    pattern:
      /(bang cap|cap bac|chuc vu|ky nang|nhom ky nang|trinh do ky nang|hop dong|education|position|skill|contract)/,
    key: 'education',
    icon: 'fi fi-rr-award',
  },
  {
    pattern: /(khai bao|danh muc|tai khoan ke toan|tai khoan ngam dinh|menu|app config|cai dat he thong)/,
    key: 'database',
    icon: 'fi fi-rr-database',
  },
  { pattern: /(chuyen tien noi bo|doi tru|transfer|reconcile)/, key: 'transfer', icon: 'fi fi-rr-repeat' },
  { pattern: /(cong no|tien mat|cash|thu chi)/, key: 'money', icon: 'fi fi-rr-money' },
  {
    pattern: /(ngan hang|tai khoan ngan hang|payment|thanh toan|doi tac tra gop|tra gop|bank)/,
    key: 'bank',
    icon: 'fi fi-rr-credit-card',
  },
  {
    pattern: /(chung tu|phieu|hoa don|invoice|voucher|doi tru|cong no|debit)/,
    key: 'voucher',
    icon: 'fi fi-rr-file-invoice',
  },
  {
    pattern: /(lai lo|hoa hong|dong tien|cash flow|profit|discount|chiet khau|commission|vat)/,
    key: 'reporting',
    icon: 'fi fi-rr-chart-pie-alt',
  },
  {
    pattern:
      /(bom|xuat xu|hang |hang$|manufacturer|origin|material|bao bi|package|stocks take|kiem ke|xuat kho|nhap kho)/,
    key: 'inventory',
    icon: 'fi fi-rr-package',
  },
  { pattern: /(cong ty|loai mien|mien|business type|map|dia diem)/, key: 'region', icon: 'fi fi-rr-marker' },
  { pattern: /(tin tuc noi bo|thong bao noi bo|co dong)/, key: 'internal-news', icon: 'fi fi-rr-megaphone' },
  { pattern: /(giao hang|delivery|truck)/, key: 'delivery', icon: 'fi fi-rr-truck-side' },
  { pattern: /(chi nhanh|cua hang|store|shop|branch|hospital)/, key: 'branch', icon: 'fi fi-rr-shop' },
  {
    pattern: /(nhan su|nhan vien|chuyen gia|bac si|doctor|staff|user group|phong ban)/,
    key: 'staff',
    icon: 'fi fi-rr-users-alt',
  },
  { pattern: /(san pham|dich vu|item|product|brand|category|service|loa)/, key: 'product', icon: 'fi fi-rr-speaker' },
  { pattern: /(noi dung|cms|banner)/, key: 'content', icon: 'fi fi-rr-folder' },
  { pattern: /(tai lieu|file|folder|huong dan|manual|guide)/, key: 'document', icon: 'fi fi-rr-book-open-cover' },
  { pattern: /(tuyen dung|ung vien|candidate|recruit)/, key: 'recruitment', icon: 'fi fi-rr-briefcase' },
  {
    pattern: /(he thong|setting|module|permission|function|workflow|config)/,
    key: 'system',
    icon: 'fi fi-rr-settings',
  },
  { pattern: /(khach hang|customer|contact|crm)/, key: 'customer', icon: 'fi fi-rr-user' },
  { pattern: /(khuyen mai|voucher|promotion|uu dai)/, key: 'promotion', icon: 'fi fi-rr-ticket' },
  {
    pattern: /(tai chinh|ngan hang|tai khoan|hoa don|cong no|thu chi|invoice)/,
    key: 'finance',
    icon: 'fi fi-rr-calculator',
  },
  {
    pattern: /(ke toan|accounting|chung tu|chuyen tien|khai bao|loai thu|loai chi|ky ke toan)/,
    key: 'accounting',
    icon: 'fi fi-rr-calculator',
  },
  {
    pattern: /(mua hang|purchase|supplier|de nghi nhap|don dat hang)/,
    key: 'purchase',
    icon: 'fi fi-rr-shopping-cart',
  },
  { pattern: /(kho|ton kho|stocks|warehouse|kiem kho|nhap kho|xuat kho)/, key: 'warehouse', icon: 'fi fi-rr-boxes' },
  { pattern: /(ban hang|sales|order|don hang)/, key: 'sales', icon: 'fi fi-rr-badge-dollar' },
  { pattern: /(bao gia|gia san pham|price)/, key: 'price', icon: 'fi fi-rr-badge-dollar' },
  { pattern: /(du an|project)/, key: 'project', icon: 'fi fi-rr-briefcase' },
  { pattern: /(bao cao|report|chart)/, key: 'report', icon: 'fi fi-rr-chart-line-up' },
  { pattern: /(thong bao|announce|notification)/, key: 'notify', icon: 'fi fi-rr-bell' },
  { pattern: /(tin tuc|news)/, key: 'news', icon: 'fi fi-rr-book-open-cover' },
  { pattern: /(muon|tra hang|borrow|return)/, key: 'exchange', icon: 'fi fi-rr-boxes' },
];

const PAGE_DESCRIPTION_MAP = [
  {
    match: '/add',
    text: 'Thiết lập biểu mẫu mới theo đúng luồng dữ liệu, field và validate của portal.',
  },
  {
    match: '/edit',
    text: 'Cập nhật thông tin hiện có mà không thay đổi cấu trúc dữ liệu hay quy tắc kiểm tra.',
  },
  {
    match: '/detail',
    text: 'Theo dõi chi tiết nghiệp vụ, trạng thái và dữ liệu liên quan trên cùng một giao diện quản trị.',
  },
];

const ACTION_ICON_MAP = [
  { pattern: /(tìm kiếm|search)/i, icon: 'fi fi-rr-filter' },
  { pattern: /(làm mới|refresh|reset)/i, icon: 'fi fi-rr-refresh' },
  { pattern: /(thao tác|action)/i, icon: 'fi fi-rr-settings' },
  { pattern: /(chọn tất cả|select all|chọn)/i, icon: 'fi fi-rr-check' },
  { pattern: /(chỉnh sửa|cập nhật)/i, icon: 'fi fi-rr-edit' },
  { pattern: /(lưu|hoàn tất)/i, icon: 'fi fi-rr-disk' },
  { pattern: /(đóng|quay về)/i, icon: 'fi fi-rr-cross-small' },
  { pattern: /(hủy|huỷ)/i, icon: 'fi fi-rr-rotate-right' },
  { pattern: /(in|print)/i, icon: 'fi fi-rr-print' },
  { pattern: /thêm/i, icon: 'fi fi-rr-add' },
  { pattern: /(lọc|filter)/i, icon: 'fi fi-rr-filter' },
  { pattern: /(xuất|download)/i, icon: 'fi fi-rr-download' },
  { pattern: /(nhập|upload)/i, icon: 'fi fi-rr-upload' },
  { pattern: /(xóa|xoá|delete)/i, icon: 'fi fi-rr-trash' },
  { pattern: /(chi tiết|xem)/i, icon: 'fi fi-rr-eye' },
];

const ACTION_LABEL_MAP = [
  { pattern: /fi-rr-eye-crossed/i, label: 'Ẩn' },
  { pattern: /fi-rr-(eye|preview)/i, label: 'Xem chi tiết' },
  { pattern: /fi-rr-(edit|pencil)/i, label: 'Chỉnh sửa' },
  { pattern: /fi-rr-trash/i, label: 'Xóa' },
  { pattern: /fi-rr-print/i, label: 'In' },
  { pattern: /fi-rr-(download|inbox-out)/i, label: 'Tải xuống' },
  { pattern: /fi-rr-(upload|cloud-upload|inbox-in)/i, label: 'Tải lên' },
  { pattern: /fi-rr-(filter|search)/i, label: 'Tìm kiếm' },
  { pattern: /fi-rr-(add|plus)/i, label: 'Thêm mới' },
  { pattern: /fi-rr-copy/i, label: 'Sao chép' },
  { pattern: /fi-rr-check/i, label: 'Xác nhận' },
  { pattern: /fi-rr-disk/i, label: 'Lưu' },
  { pattern: /fi-rr-(refresh|rotate-right)/i, label: 'Làm mới' },
  { pattern: /fi-rr-cross/i, label: 'Đóng' },
  { pattern: /fi-rr-paper-plane/i, label: 'Gửi' },
  { pattern: /fi-rr-lock/i, label: 'Khóa' },
];

const SPECIAL_TOKEN_MAP = {
  tnh: 'Bảo Châu',
  erp: 'ERP',
  retail: 'Retail',
  crm: 'CRM',
  pbx: 'PBX',
  vat: 'VAT',
  api: 'API',
  sku: 'SKU',
  ncc: 'NCC',
  doa: 'DOA',
  ltv: 'LTV',
  mql: 'MQL',
  aov: 'AOV',
  otif: 'OTIF',
  sla: 'SLA',
  cmnd: 'CMND',
  cccd: 'CCCD',
  sms: 'SMS',
};

const PORTAL_ICON_COMPONENT_MAP = {
  'fi-rr-apps': FiGrid,
  'fi-rr-grid': FiGrid,
  'fi-rr-grid-alt': FiGrid,
  'fi-rr-qrcode': FiGrid,
  'fi-rr-file-excel': FiGrid,
  'fi-rr-file-spreadsheet': FiGrid,
  'fi-rr-list-check': FiClipboard,
  'fi-rr-list': FiClipboard,
  'fi-rr-layers': FiLayers,
  'fi-rr-menu-burger': FiMenu,
  'fi-rr-menu-dots': FiMoreHorizontal,
  'fi-rr-megaphone': FiBell,
  'fi-rr-truck-side': FiTruck,
  'fi-rr-shop': FiShoppingBag,
  'fi-rr-users-alt': FiUsers,
  'fi-rr-user-add': FiUserPlus,
  'fi-rr-user-time': FiClock,
  'fi-rr-headset': FiHeadphones,
  'fi-rr-speaker': FiHeadphones,
  'fi-rr-folder': FiFolder,
  'fi-rr-briefcase': FiBriefcase,
  'fi-rr-tool-box': FiBriefcase,
  'fi-rr-wrench': FiTool,
  'fi-rr-exclamation': FiAlertTriangle,
  'fi-rr-book-open-cover': FiBookOpen,
  'fi-rr-settings': FiSettings,
  'fi-rr-settings-sliders': FiSettings,
  'fi-rr-user': FiUser,
  'fi-rr-user-check': FiUserCheck,
  'fi-rr-ticket': FiGift,
  'fi-rr-gift': FiGift,
  'fi-rr-calculator': FiDollarSign,
  'fi-rr-sack-dollar': FiDollarSign,
  'fi-rr-shopping-cart': FiShoppingCart,
  'fi-rr-shopping-cart-add': FiShoppingCart,
  'fi-rr-garage': FiArchive,
  'fi-rr-boxes': FiArchive,
  'fi-rr-badge-dollar': FiTag,
  'fi-rr-apps-sort': FiShoppingBag,
  'fi-rr-tags': FiTag,
  'fi-rr-chart-line-up': FiBarChart2,
  'fi-rr-chart-pie-alt': FiPieChart,
  'fi-rr-percentage': FiPercent,
  'fi-rr-calendar': FiCalendar,
  'fi-rr-phone-call': FiPhoneCall,
  'fi-rr-globe': FiGlobe,
  'fi-rr-award': FiAward,
  'fi-rr-credit-card': FiCreditCard,
  'fi-rr-cash-register': FiCreditCard,
  'fi-rr-database': FiDatabase,
  'fi-rr-repeat': FiRepeat,
  'fi-rr-shuffle': FiShuffle,
  'fi-rr-dollar': FiDollarSign,
  'fi-rr-money': FiDollarSign,
  'fi-rr-marker': FiMapPin,
  'fi-rr-envelope-open-text': FiMail,
  'fi-rr-envelope': FiMail,
  'fi-rr-bell': FiBell,
  'fi-rr-reply-all': FiCornerUpLeft,
  'fi-rr-edit': FiEdit2,
  'fi-rr-lock': FiLock,
  'fi-rr-disk': FiSave,
  'fi-rr-cross-circle': FiX,
  'fi-rr-cross-small': FiX,
  'fi-rr-cross': FiX,
  'fi-rr-rotate-right': FiRotateCw,
  'fi-rr-refresh': FiRotateCw,
  'fi-rr-undo': FiCornerUpLeft,
  'fi-rr-undo-alt': FiCornerUpLeft,
  'fi-rr-print': FiPrinter,
  'fi-rr-add': FiPlus,
  'fi-rr-plus': FiPlus,
  'fi-rr-plus-small': FiPlus,
  'fi-rr-search': FiSearch,
  'fi-rr-search-alt': FiSearch,
  'fi-rr-filter': FiFilter,
  'fi-rr-download': FiDownload,
  'fi-rr-upload': FiUpload,
  'fi-rr-cloud-upload-alt': FiUpload,
  'fi-rr-cloud-upload': FiUpload,
  'fi-rr-paper-plane': FiSend,
  'fi-rr-inbox-in': FiUpload,
  'fi-rr-inbox-out': FiDownload,
  'fi-rr-copy-alt': FiCopy,
  'fi-rr-copy': FiCopy,
  'fi-rr-trash': FiTrash2,
  'fi-rr-eye': FiEye,
  'fi-rr-eye-crossed': FiEyeOff,
  'fi-rr-sign-in-alt': FiLogIn,
  'fi-rr-sign-out-alt': FiLogOut,
  'fi-rr-angle-small-down': FiChevronDown,
  'fi-rr-angle-small-up': FiChevronUp,
  'fi-rr-angle-small-left': FiChevronLeft,
  'fi-rr-angle-small-right': FiChevronRight,
  'fi-rr-arrow-right': FiArrowRight,
  'fi-rr-arrow-trend-up': FiTrendingUp,
  'fi-rr-arrow-trend-down': FiTrendingDown,
  'fi-rr-angle-circle-left': FiArrowLeftCircle,
  'fi-rr-check': FiCheck,
  'fi-rr-minus': FiMinus,
  'fi-rr-minus-small': FiMinus,
  'fi-rr-barcode': FaBarcode,
  'fi-rr-barcode-read': FaBarcode,
  'fi-rr-clip': FiPaperclip,
  'fi-rr-receipt': FiFileText,
  'fi-rr-document': FiFileText,
  'fi-rr-document-signed': FiFileText,
  'fi-rr-file-signature': LuFileSignature,
  'fi-rr-file-invoice': FiFileText,
  'fi-rr-file-invoice-dollar': FiFileText,
  'fi-rr-package': FiPackage,
  'fi-rr-file': FiFile,
  'fa-lock': FiLock,
  'fa-edit': FiEdit2,
  'fa-trash': FiTrash2,
  'fa-eye': FiEye,
  'fa-check-square': FiCheck,
  'fa-street-view': FiUsers,
  'fa-tasks': FiClipboard,
  'fa-share': FiShare2,
  'fa-rss': FiRss,
  'fa-comments': FiMessageCircle,
  'fa-cogs': FiSettings,
  'fa-list-ul': FiList,
  'fa-files-o': FiFileText,
  'fa-download': FiDownload,
  'fa-upload': FiUpload,
  'fa-copy': FiCopy,
  'fa-paperclip': FiPaperclip,
  'fa-file': FiFile,
  'fa-print': FiPrinter,
  'fa-table': FiGrid,
  'fa-plus': FiPlus,
  'fa-minus': FiMinus,
  'fa-save': FiSave,
  'fa-paper-plane': FiSend,
  'fa-chevron-left': FiChevronLeft,
  'fa-chevron-right': FiChevronRight,
  'fa-angle-down': FiChevronDown,
  'fa-sort-desc': FiChevronDown,
  'fa-sort-asc': FiChevronUp,
  'fa-sort': FiChevronDown,
  'fa-stop': FiX,
  'fa-arrows-h': FiRepeat,
};

const toLookupKey = (value = '') =>
  String(value || '')
    .replace(/[đĐ]/g, 'd')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9]+/g, ' ')
    .trim()
    .toLowerCase();

const formatToken = (token = '', isFirst = false) => {
  const normalizedToken = token.toLowerCase();

  if (SPECIAL_TOKEN_MAP[normalizedToken]) {
    return SPECIAL_TOKEN_MAP[normalizedToken];
  }

  if (!token) {
    return '';
  }

  return isFirst ? normalizedToken.charAt(0).toUpperCase() + normalizedToken.slice(1) : normalizedToken;
};

const formatSegment = (segment = '') => {
  const tokens = String(segment || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  return tokens.map((token, index) => formatToken(token, index === 0)).join(' ');
};

const toSentenceCase = (value = '') =>
  String(value || '')
    .split(/([/-])/)
    .map((piece) => {
      if (piece === '/' || piece === '-') {
        return ` ${piece} `;
      }

      return formatSegment(piece);
    })
    .join('')
    .replace(/\s+/g, ' ')
    .trim();

export const normalizePortalLabel = (label = '') => {
  const normalized = String(label || '')
    .trim()
    .replace(/\s+/g, ' ');

  const lookupKey = toLookupKey(normalized);
  const matchedRule = DISPLAY_LABEL_RULES.find((item) => item.pattern.test(lookupKey));
  const mappedValue = matchedRule?.value || DISPLAY_LABEL_MAP[lookupKey] || normalized;

  return toSentenceCase(mappedValue);
};

export const normalizePortalText = (value = '') => {
  const raw = String(value ?? '');
  if (!raw) return raw;

  const replaceCaseAware = (input, pattern, replacement) =>
    input.replace(pattern, (match) => (/^[a-zà-ỹ]/.test(match) ? replacement.toLowerCase() : replacement));

  let nextValue = raw;

  const replaceRules = [
    [/\bChọn\s*phòng ban\s*[,/]\s*chuyên khoa\b/gi, 'Chọn phòng ban'],
    [/\bPhòng ban\s*[,/]\s*chuyên khoa\b/gi, 'Phòng ban'],
    [/\bMã\s*bệnh viện\s*\/\s*cơ sở\b/gi, 'Mã chi nhánh / cửa hàng'],
    [/\bTên\s*bệnh viện\s*\/\s*cơ sở\s*\(tiếng anh\)\b/gi, 'Tên chi nhánh / cửa hàng (tiếng anh)'],
    [/\bTên\s*bệnh viện\s*\/\s*cơ sở\b/gi, 'Tên chi nhánh / cửa hàng'],
    [/\bLoại hình\s*bệnh viện\s*\/\s*cơ sở\b/gi, 'Loại hình chi nhánh / cửa hàng'],
    [/\bBệnh viện\s*[,/]\s*cơ sở\b/gi, 'Chi nhánh / Cửa hàng'],
    [/\bCơ sở\s*[/]\s*Bệnh viện\b/gi, 'Chi nhánh / Cửa hàng'],
    [/\bBệnh viện\s*[/]\s*Chi nhánh\b/gi, 'Chi nhánh / Cửa hàng'],
    [/\bBệnh viện\s*,\s*chi nhánh\b/gi, 'Chi nhánh / Cửa hàng'],
    [/\bBệnh viện\s*\/\s*cơ sở\b/gi, 'Chi nhánh / Cửa hàng'],
    [/\bCơ sở\s*bệnh viện\b/gi, 'Chi nhánh / Cửa hàng'],
    [/\bBệnh viện\b/gi, 'Chi nhánh'],
    [/\bGiường bệnh\b/gi, 'Điểm bán'],
    [/\bBệnh nhân\b/gi, 'Khách hàng'],
    [/\bChuyên gia\s*\/\s*Bác sĩ\b/gi, 'Nhân sự'],
    [/\bHospital\b/gi, 'Branch'],
    [/\bhospital\b/gi, 'branch'],
  ];

  replaceRules.forEach(([pattern, replacement]) => {
    nextValue = replaceCaseAware(nextValue, pattern, replacement);
  });

  return nextValue;
};

export const getPortalMenuIcon = (label = '') => {
  const normalizedLabel = normalizePortalLabel(label);
  const lookupKey = toLookupKey(normalizedLabel);
  const matchedRule = MENU_ICON_RULES.find((item) => item.pattern.test(lookupKey));

  return matchedRule?.icon || 'fi fi-rr-apps';
};

export const getPortalMenuIconKey = (label = '') => {
  const normalizedLabel = normalizePortalLabel(label);
  const lookupKey = toLookupKey(normalizedLabel);
  const matchedRule = MENU_ICON_RULES.find((item) => item.pattern.test(lookupKey));

  return matchedRule?.key || 'dashboard';
};

export const resolveIconClass = (icon = '') => {
  const tokens = String(icon || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  if (tokens.length === 0) {
    return '';
  }

  const normalizedTokens = tokens.filter((token, index) => token !== 'fi' && tokens.indexOf(token) === index);
  return ['fi', ...normalizedTokens].join(' ').trim();
};

export const getPortalIconToken = (icon = '') => {
  const tokens = String(icon || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  const directToken = tokens.find((token) => token.startsWith('fi-'));
  if (directToken) {
    return directToken;
  }

  const fontAwesomeToken = tokens.find((token) => token.startsWith('fa-'));
  if (fontAwesomeToken) {
    return fontAwesomeToken;
  }

  if (tokens.length === 0) {
    return '';
  }

  const lastToken = tokens[tokens.length - 1];
  return lastToken.startsWith('fi-') ? lastToken : `fi-rr-${lastToken}`;
};

export const getPortalIconComponent = (icon = '') => {
  const iconToken = getPortalIconToken(icon);
  return PORTAL_ICON_COMPONENT_MAP[iconToken] || null;
};

export const PortalIcon = ({ icon = '', className = '', style = {}, ...props }) => {
  const IconComponent = getPortalIconComponent(icon);
  const accessibilityProps = props['aria-label'] ? { role: 'img' } : { 'aria-hidden': 'true' };

  if (!IconComponent) {
    const fallbackClassName = resolveIconClass(icon);

    if (!fallbackClassName) {
      return null;
    }

    return (
      <span className={className} style={style} {...accessibilityProps} {...props}>
        <i className={fallbackClassName} aria-hidden='true' />
      </span>
    );
  }

  return (
    <span className={className} style={style} {...accessibilityProps} {...props}>
      <IconComponent />
    </span>
  );
};

export const getPageDescription = (title = '', pathname = '') => {
  const matchedPage = PAGE_DESCRIPTION_MAP.find((item) => pathname.includes(item.match));

  if (matchedPage) {
    return matchedPage.text;
  }

  if (pathname === '/' || pathname === '/dashboard') {
    return 'Theo dõi tổng quan chỉ số, tiến độ và trạng thái vận hành trên cùng một dashboard điều phối.';
  }

  const normalizedTitle = normalizePortalText(normalizePortalLabel(title || 'nghiệp vụ')).toLowerCase();
  return `Quản lý ${normalizedTitle}, thao tác nhanh và giữ nguyên toàn bộ cấu trúc dữ liệu của portal.`;
};

export const getBrandUserTitle = (user) => {
  return String(user?.full_name || '').trim() || String(user?.user_name || '').trim() || 'Người dùng Bảo Châu';
};

export const getBrandUserSubtitle = (user) => {
  return (
    String(user?.position_name || '').trim() ||
    String(user?.department_name || '').trim() ||
    String(user?.user_name || '').trim() ||
    (Number(user?.isAdministrator) === 1 ? 'Tài khoản quản trị' : 'Nhân sự Bảo Châu')
  );
};

const isNoopMenuPath = (path = '') => {
  const normalizedPath = String(path || '').trim();

  return !normalizedPath || normalizedPath === '#' || normalizedPath.startsWith('#') || normalizedPath.startsWith('/#');
};

export const pruneNoopLeafMenuTree = (items = []) => {
  return (items || []).reduce((accumulator, item) => {
    const children = Array.isArray(item?.children) ? pruneNoopLeafMenuTree(item.children) : [];
    const path = item?.path || item?.link_menu || '';

    if (children.length === 0 && isNoopMenuPath(path)) {
      return accumulator;
    }

    accumulator.push({
      ...item,
      children: children.length > 0 ? children : undefined,
    });

    return accumulator;
  }, []);
};

export const defaultActionIcon = (content = '') => {
  const normalized = typeof content === 'string' ? content.trim() : '';
  const matchedAction = ACTION_ICON_MAP.find((item) => item.pattern.test(normalized));
  return matchedAction?.icon || '';
};

export const defaultActionLabel = (icon = '') => {
  const normalized = typeof icon === 'string' ? icon.trim() : '';
  const matchedAction = ACTION_LABEL_MAP.find((item) => item.pattern.test(normalized));
  return matchedAction?.label || 'Thao tác';
};

export const filterMenuTree = (items = [], keyword = '') => {
  const normalizedKeyword = keyword.trim().toLowerCase();

  if (!normalizedKeyword) {
    return items;
  }

  return (items || []).reduce((accumulator, item) => {
    const children = Array.isArray(item?.children) ? filterMenuTree(item.children, keyword) : [];
    const normalizedName = normalizePortalLabel(item?.name || '').toLowerCase();
    const matchedSelf = normalizedName.includes(normalizedKeyword);

    if (matchedSelf || children.length > 0) {
      accumulator.push({
        ...item,
        children,
      });
    }

    return accumulator;
  }, []);
};
